import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { getClientes } from '@ducks/conectoresConfiguracoes';

export default function TableClientes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const clientes = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('clientes').toArray());
  const loadingClientes = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('loadingClientes'));

  const handleSearch = () => {
    dispatch(getClientes());
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Cliente',
      dataIndex: 'nmCliente',
      key: 'nmCliente',
      width: '85%',
      ...TableSearch('nmCliente', 'cliente', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'cdCliente',
      key: 'options',
      align: 'right',
      width: '15%',
      render: (text) => (
        <TableColumnOpcoes>
          <Icon.Detail action={() => history.push(`/conectores/configuracoes/${text}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey="cdCliente" columns={columns} dataSource={clientes} loading={loadingClientes} hidePagination />;
}
